<template>
  <div>
    <form @submit.prevent="saveMenuItem">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <span class="pl-2">
            {{ input ? "Edit" : "Add" }} Merchant Staff
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="2" class="pr-0">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error': errors.first('outletCode') }">
                <b-form-input
                  v-model="outletCode"
                  v-validate="'required'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first("outletCode") }}</small>
              </b-col>
              <b-col md="2" class="pr-0">
                <label>Name</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error': errors.first('name') }">
                <b-form-input
                  v-model="name"
                  v-validate="'required'"
                  type="text"
                  name="name"
                />
                <small>{{ errors.first("name") }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2" class="pr-0">
                <label>WhatsApp</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('whatsApp') }">
                <b-form-input
                  v-model="whatsApp"
                  v-validate="'required'"
                  type="text"
                  name="whatsApp"
                />
                <small>{{ errors.first("whatsApp") }}</small>
              </b-col>
              <b-col md="2" class="pr-0">
                <label>Email</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('email') }">
                <b-form-input
                  v-model="email"
                  v-validate="'required'"
                  type="text"
                  name="email"
                />
                <small>{{ errors.first('email') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>Status</label>
              </b-col>
              <b-col md="4" class="mt-1">
                <b-form-checkbox v-model="status" name="status" />
              </b-col>
              <b-col md="2" class="pr-0">
                <label>PinCode</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('pinCode') }">
                <b-form-input
                  v-model="pinCode"
                  v-validate="'required|numeric|maxLength:4|minLength:4'"
                  type="number"
                  name="pinCode"
                />
                <small>{{ errors.first('pinCode') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn v-if="submitLoading" type="submit" disabled variant="success">
            Uploading
          </b-btn>
          <b-btn
            v-if="!submitLoading"
            type="submit"
            variant="success"
          >
            {{ input ? "Update" : "Save" }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { getResponseToMTH } from '@/utils/helpers'
import constants from '@/utils/constants'
export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: 0,
      status: false,
      name: '',
      outletCode: '',
      email: '',
      whatsApp: '',
      pinCode: '',
      submitLoading: false,
      obj: {}
    }
  },
  watch: {
    obj: function(newVal) {
      if (newVal.id) {
        this.status = newVal.status === 1
        this.whatsApp = newVal.whatsApp
        this.email = newVal.email
        this.name = newVal.name
        this.outletCode = newVal.outletCode
        this.pinCode = newVal.pinCode
        this.submitLoading = false
        this.id = newVal.id
      }
    }
  },
  methods: {
    saveMenuItem() {
      this.$validator.validate().then(valid => {
        try {
          if (valid) {
             let param = {
              id: 0,
              status: 0,
              name: '',
              outletCode: '',
              email: '',
              whatsApp: '',
              pinCode: '',
            }
            console.log('this.status', this.status)
            param.status = this.status ? 1 : 0
            param.outletCode = this.outletCode
            param.email = this.email
            param.whatsApp = this.whatsApp
            param.pinCode = this.pinCode
            param.name = this.name
            param.pinCode = this.pinCode
            param.id = this.id

            if (this.input === null) {
               this.submitLoading = true
              this.$store
                .dispatch('CreateMerchantStaff', param)
                .then(response => {
                  this.submitLoading = false
                  let res = getResponseToMTH(
                    response,
                    this.$swal,
                    'Record is created'
                  )
                  if (res) {
                    this.$emit('discard-modal', true)
                    this.reset()
                  }
                  if (response.invalidMessage !== 'SUCCESS') {
                    this.$swal(
                      constants.SOMETHING_WROING,
                      response.invalidMessage,
                      constants.STATUS_ERROR
                    )
                  }
                })
                .catch(error => {
                  this.submitLoading = false
                  this.$swal(
                    constants.SOMETHING_WROING,
                    error.response.data.message,
                    constants.STATUS_ERROR
                  )
                })
            } else {
              this.$store
                .dispatch('UpdateMerchantStaff', param)
                .then(response => {
                  this.submitLoading = false
                  let res = getResponseToMTH(
                    response,
                    this.$swal,
                    constants.RECORD_IS_UPDATED
                  )
                  if (res) {
                    this.$emit('discard-modal', true)
                    this.reset()
                  }
                })
                .catch(error => {
                  this.submitLoading = false
                  this.$swal(
                    constants.SOMETHING_WROING,
                    error.response.data.message,
                    constants.STATUS_ERROR
                  )
                })
            }
          }
        } catch {
          this.submitLoading = false
        }
      })
    },

    discardModal() {
      this.reset()
      this.$emit('discard-modal')
    },
    reset() {
        this.obj = this.input
    },
  }
}
</script>
<style lang="scss">
.dropdown-trigger {
  overflow: scroll;
}
.dropdown-list {
  width: 180px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
}
.edc-mapping {
  display: flex;
  align-items: center;
}
.custom-control-label {
  span {
    margin-top: -13px;
  }
}
</style>
